/** 수량 문자열(Decimal)을 화면 표기용으로 변환 */
export const formatQuantity = (value: string | number | null | undefined) =>
  Number(value ?? 0).toLocaleString("ko-KR", { maximumFractionDigits: 3 });

/** 가용 수량이 안전재고 미만이면 보충이 필요하다. */
export const needsReplenishment = (
  available: string | number,
  safetyStock: string | number,
) => Number(available) < Number(safetyStock);
